import ObjectCreationValidator from '@/entities/validators/ObjectCreationValidator'
import { InvoiceUserDataInfoI } from '@/modules/invoice/types/api/InvoiceUserDataInfo'

export default class InvoiceUserDataInfo {
  address1: string
  address2: string
  cclastfour: string
  cctype: string
  city: string
  companyname: string
  countrycode: string
  email: string
  firstname: string
  fullname: string
  lastname: string
  phonenumber: string
  postcode: string
  state: string
  tax_id: string
  constructor(data: InvoiceUserDataInfoI) {
    this.address1 = data.address1
    this.address2 = data.address2
    this.cclastfour = data.cclastfour
    this.cctype = data.cctype
    this.city = data.city
    this.companyname = data.companyname
    this.countrycode = data.countrycode
    this.email = data.email
    this.firstname = data.firstname
    this.fullname = data.fullname
    this.lastname = data.lastname
    this.phonenumber = data.phonenumber
    this.postcode = data.postcode
    this.state = data.state
    this.tax_id = data.tax_id

    ObjectCreationValidator.validate(this)
  }
}
